import React from 'react'
import { Link } from 'react-router-dom'

export const LOGIN_CONSENT_PARTS = [
    { text: 'I agree with the ' },
    { text: 'End User License Agreement', href: 'https://stashfin.com/licence_agreement' },
    { text: ', ' },
    { text: 'Privacy Policy', href: 'https://stashfin.com/privacy-policies' },
    { text: ', ' },
    { text: 'Platform Declaration', href: 'https://stashfin.com/platform_declaration' },
    { text: ', ' },
    { text: 'User Consent for KYC', href: 'https://stashfin.com/user_consent_for_kyc' },
    { text: ',  User consent for ' },
    { text: 'TUCIBIL', href: 'https://stashfin.com/user_consent_for_kyc' },
    { text: ' and ' },
    { text: 'Fair Practices Code', href: 'https://stashfin.com/fpc' },
    { text: ' on the Stashfin App/Website. I authorize Stashfin to access my credit report from credit bureaus.' },
]

export const LOGIN_CONSENT_TEXT = LOGIN_CONSENT_PARTS.map((part) => part.text).join('')

export function LoginConsentCopy() {
    return (
        <p>
            {LOGIN_CONSENT_PARTS.map((part, index) => (
                part.href ? (
                    <Link key={index} to={part.href} target="_blank">{part.text}</Link>
                ) : (
                    <React.Fragment key={index}>{part.text}</React.Fragment>
                )
            ))}
        </p>
    )
}
